<template>
    <div class="main__content">
        <div class="title">
            <slot name="title"></slot>
        </div>
        <div class="desc">
            <slot name="desc"></slot>
        </div>
        <div class="content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.main__content{
    width: 100%;
    position: relative;
}
.title{
    /* Header/H3: 24px Medium */
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 16px;
}
.desc{
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 28px;
    max-width: 304px;
}
.content{
    width: 100%;
}
@media (max-width: 1024px) {
    .main__content{
        padding-bottom: 100px;
    }
}
</style>